/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Upload_Progress_LabelInputs */



/**
* | output |
* | --- |
* | "Upload progress" |
*
* @param {Upload_Progress_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const upload_progress_label = /** @type {((inputs?: Upload_Progress_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Upload_Progress_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Progression du téléversement")
	if (locale === "de") return /** @type {LocalizedString} */ ("Upload-Fortschritt")
	if (locale === "it") return /** @type {LocalizedString} */ ("Caricamento in corso")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Ход загрузки")
	if (locale === "es") return /** @type {LocalizedString} */ ("Progreso de subida")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("上传进度")
	if (locale === "ja") return /** @type {LocalizedString} */ ("アップロードの進行状況")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अपलोड प्रगति")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Progresso do carregamento")
	return /** @type {LocalizedString} */ ("Upload progress")
});